import React from 'react';
import './footer.scss';
import {Col, Container, Nav, Row, Form, Button} from 'react-bootstrap';

function Footer() {
  return (
    <div className="footer pb50">
      <Container>
        <Row>
          <Col sm={6} md={4}>
            <h3>Get in Touch</h3>
            <p className="icon phone">+357 99 514991</p>
            <p className="icon email pb50">info@amazing-world.eu</p>

            <h3>Follow Us</h3>
            <ul className="soc-media">
              <li><Nav.Link href="https://www.facebook.com/GlampingCyprus" target="_blank" className="fb"></Nav.Link>
              </li>
              <li><Nav.Link href="https://www.instagram.com/glamping_domes_cy/?hl=en" target="_blank"
                            className="insta"></Nav.Link></li>
            </ul>

          </Col>
          <Col sm={6} md={3}>
            <ul className="menu">
              <li><Nav.Link href="#about">Our Story</Nav.Link></li>
              <li><Nav.Link href="#accommodation">Our Domes</Nav.Link></li>
              <li><Nav.Link href="#services">Your Stay</Nav.Link></li>
              <li><Nav.Link href="#events">Gatherings</Nav.Link></li>
              <li><Nav.Link href="#gallery">Gallery</Nav.Link></li>
              <li><Nav.Link href="#places">Attractions</Nav.Link></li>
              <li><Nav.Link href="#contacts">Contacts</Nav.Link></li>
            </ul>
          </Col>
          <Col md={5}>
            <h3 className="color-white">Send a Message</h3>

            <Form className="contact-us-form" action="#">
              <Row>
                <Col sm={6}>
                  <Form.Group className="mb-5" controlId="formBasicEmail">
                    <Form.Label>Your Name</Form.Label>
                    <Form.Control type="text" placeholder="Name Surname"/>
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group className="mb-5" controlId="formBasicEmail">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control type="email" placeholder="Enter email"/>
                    {/*<Form.Text className="text-muted">
                      We'll never share your email with anyone else.
                    </Form.Text>*/}
                  </Form.Group>
                </Col>
                <Col sm={12}>
                  <Form.Group className="mb-5" controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Your Message</Form.Label>
                    <Form.Control as="textarea" rows={5}/>
                  </Form.Group>
                </Col>
                <Col sm={12}>
                  <Button variant="primary" type="submit">
                    Send Message
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
          <Col sm={12} className="pt50">
          <p>© 2026. This property was formerly known as «Amazing Cyprus Glamping Domes GL». Trademark No. EE57748A (35680981).</p>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Footer;
